import { ApplicationExceptionHandler } from "@gtpl/shared-utils/error-messages";
import { Body, Controller, Post } from "@nestjs/common";
import { ApiTags } from "@nestjs/swagger";
import { ExchangeRatesService } from "./exchange-rates.service";
import { CommonResponse } from "@gtpl/shared-models/production-management";
import { ExchangeIdReq, ExchangeRatesRequest, ExchangeRatesResponseModel } from "@gtpl/shared-models/masters";

@ApiTags('exchangeRates')
@Controller('exchangeRates')
export class exchangeRatesController {
    constructor(
        private endCustomersService: ExchangeRatesService,
        private readonly applicationExceptionhandler: ApplicationExceptionHandler,

    ) { }
    /**
     * creates or updates a value of Exchange Rates
     * @param EndCustomersDto Exchange Rates DTO
     * @returns CommonResponse
     */
    @Post('/createExchangeRate')
    async createExchangeRate(@Body() req: ExchangeRatesRequest, isUpdate: boolean = false): Promise<ExchangeRatesResponseModel> {
        try {
            console.log(req,'controller')
            return await this.endCustomersService.createExchangeRate(req, false);
        } catch (error) {
            return this.applicationExceptionhandler.returnException(ExchangeRatesResponseModel, error)
        }
    }

    @Post('/activateDeactivateExchange')
    async activateDeactivateExchange(@Body() req: ExchangeRatesRequest): Promise<ExchangeRatesResponseModel> {
        try {
            return await this.endCustomersService.activateDeactivateExchange(req);
        } catch (error) {
            return this.applicationExceptionhandler.returnException(ExchangeRatesResponseModel, error)
        }
    }
    
    @Post('/getAllExchangeRates')
    async getAllExchangeRates(@Body() req: ExchangeIdReq): Promise<ExchangeRatesResponseModel> {
        try {
            return await this.endCustomersService.getAllExchangeRates(req);
        } catch (error) {
            return this.applicationExceptionhandler.returnException(ExchangeRatesResponseModel, error)
        }
    }
    
    @Post('/getAllActiveExchangeRates')
    async getAllActiveExchangeRates(): Promise<ExchangeRatesResponseModel> {
        try {
            return await this.endCustomersService.getAllActiveExchangeRates();
        } catch (error) {
            return this.applicationExceptionhandler.returnException(ExchangeRatesResponseModel, error)
        }
    }
}